
import { Options, Vue } from 'vue-class-component';
import { webFileService } from '../services/WebFileService';
import {
    TrelloList,
    TrelloCard,
    TrelloExport,
    trelloToScrumblrService,
    ExportOptions,
    ScrumblrExport,
} from '../services/TrelloToScrumblrService';

@Options({
    props: {
        msg: String,
    },
})
export default class TrelloToScrumblr extends Vue {
    trelloExport: null|TrelloExport = null;
    scrumblrExport: null|ScrumblrExport = null;

    exportLists: {list: TrelloList; export: boolean}[] = [];
    deletedCardsPolicy: ExportOptions['deletedCardsPolicy'] = 'change-color';

    selectedTrelloFile(): void {
        webFileService
            .loadJsonFromInputFile(this.$refs.trelloExportInput as HTMLInputElement)
            .then(trelloToScrumblrService.checkTrelloExport)
            .then(trelloExport => {
                this.trelloExport = trelloToScrumblrService.checkTrelloExport(trelloExport);

                this.exportLists = this.trelloExport.lists
                    .filter(list => !list.closed)
                    .map(list => ({
                        list,
                        export: true,
                    }))
                ;
            })
            .catch(alert)
        ;
    }

    selectedScrumblrFile(): void {
        webFileService
            .loadJsonFromInputFile(this.$refs.scrumblrExportInput as HTMLInputElement)
            .then(trelloToScrumblrService.checkScrumblrExport)
            .then(scrumblrExport => this.scrumblrExport = scrumblrExport)
            .catch(alert)
        ;
    }

    cardsInList(list: TrelloList): TrelloCard[] {
        if (!this.trelloExport) {
            throw new Error('Trello export not yet loaded');
        }

        return this.trelloExport.cards
            .filter(card => !card.closed)
            .filter(card => card.idList === list.id)
        ;
    }

    downloadScrumblrExport() {
        if (null === this.trelloExport) {
            throw new Error('Trello export not yet loaded');
        }

        const options: ExportOptions = {
            idLists: this.exportLists
                .filter(exportList => exportList.export)
                .map(exportList => exportList.list.id)
            ,
            deletedCardsPolicy: this.deletedCardsPolicy,
        };

        const result = trelloToScrumblrService.generateScrumblrFromTrello(
            this.trelloExport,
            options,
            this.scrumblrExport,
        );

        webFileService.downloadAsTextFile(
            JSON.stringify(result),
            'trello-to-scrumblr.json',
        );
    }
}
